import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const PrivateRoute = ({ allowedRole }) => {
  const token = localStorage.getItem("token");

  if (!token)
    return (
      localStorage.clear(),
      sessionStorage.clear(),
      (<Navigate to="/" replace />)
    );

  try {
    const decoded = jwtDecode(token);
    return decoded.role === allowedRole ? (
      <Outlet />
    ) : (
      (sessionStorage.clear(),
      (localStorage.clear(), (<Navigate to="/" replace />)))
    );
  } catch {
    localStorage.clear();
    sessionStorage.clear();
    return <Navigate to="/" replace />;
  }
};

export default PrivateRoute;
